// @flow
import * as React from 'react';

type Props = {|
  color?: string,
  height: number,
|};

//GifIcon is a Gif Icon designed to be 10*14. GifIcon will scale the aspect ratio if a different height is provided
export default function GifIcon({ color = '#333', height }: Props) {
  const width = (height * 14) / 10;
  const dPath =
    'M20.571 8.573h-3.428V12h1.714v1.715h-1.714v3.428h-1.714V6.86h5.142v1.714zM12 17.144V6.86h1.714v10.285H12zm-1.714-8.571H5.143v6.857H8.57v-1.714H6.857V12h3.429v5.143H3.429V6.86h6.857v1.714zM5.143 3.43A5.143 5.143 0 0 0 0 8.573v6.857a5.143 5.143 0 0 0 5.143 5.143h13.714A5.143 5.143 0 0 0 24 15.43V8.573a5.143 5.143 0 0 0-5.143-5.143H5.143z';
  return (
    <svg width={width} height={height} viewBox="3 3 18 18" xmlns="http://www.w3.org/2000/svg">
      <path fill={color} d={dPath} />
    </svg>
  );
}
